<template>
  <div class="p-2 mt-1 mb-3 shadow bg-white">

    <div class="row">
      <div class="col-12 col-md-4 order-md-2 mb-2 mb-md-0">

        <div class="form-row align-items-center">
          <div class="col-auto">
            <button
              class="btn btn-sm btn-outline-info"
              v-b-tooltip.hover
              title="Refresh"
              @click="onRefresh">
              <i class="fas fa-sync-alt" />
            </button>
          </div>

          <div class="col">
            <form @submit.prevent="onSearch(searchInput)">
              <input
                v-model="searchInput"
                class="form-control form-control-sm"
                placeholder="Cari...">
                <!-- :value="search" -->
                <!-- @keyup.enter="onSearch($event.target.value)" -->
            </form>
          </div>
<!-- 
          <div class="col-auto">
            <button
              class="btn btn-sm btn-outline-primary"
              v-b-tooltip.hover
              title="Filter"
              v-b-toggle.collapse-filter>
              <i class="fas fa-filter"></i>
            </button>
          </div>
 -->
        </div>
      </div>

      <div class="col-12 col-md-8 order-md-1 text-center text-md-left">
        <div v-if="!isReadOnlyUser">
          <slot name="additionalButton" v-if="buttonAppend" />

          <button
            class="btn btn-sm btn-primary btn-icon-split"
            v-if="!accessWithoutAdd && !withoutFormData"
            v-b-tooltip.hover
            title="Tambah"
            @click="createNewItem">
            <span class="icon">
              <i class="fas fa-plus" />
            </span>
            <span class="text d-none d-lg-inline-block">Tambah</span>
          </button>

          <button
            class="btn btn-sm btn-info btn-icon-split"
            v-if="!accessWithoutDetail && !withoutDetailData"
            :disabled="!selectedItem"
            v-b-tooltip.hover
            title="Detail"
            @click="detailItem">
            <span class="icon">
              <i class="fas fa-info-circle" />
            </span>
            <span class="text d-none d-lg-inline-block">Detail</span>
          </button>

          <button
            class="btn btn-sm btn-warning btn-icon-split"
            v-if="!accessWithoutEdit && !withoutFormData"
            :disabled="!selectedItem"
            v-b-tooltip.hover
            title="Ubah"
            @click="editRow">
            <span class="icon">
              <i class="fas fa-edit" />
            </span>
            <span class="text d-none d-lg-inline-block">Ubah</span>
          </button>

          <template v-if="!accessWithoutDelete">
            <button
              class="btn btn-sm btn-danger btn-icon-split"
              :disabled="!selectedItem"
              v-b-tooltip.hover
              title="Hapus"
              id="popover-delete">
              <span class="icon">
                <i class="fas fa-trash" />
              </span>
              <span class="text d-none d-lg-inline-block">Hapus</span>
            </button>

            <b-popover target="popover-delete" triggers="focus" placement="top">
              <template v-slot:title>Yakin?</template>
              <button class="btn btn-sm btn-outline-danger" @click="deleteItem">Iya, hapus saja</button>
            </b-popover>
          </template>

          <slot name="additionalButton" v-if="!buttonAppend"/>
        </div>
      </div>
    </div>

    <b-collapse visible id="collapse-filter" class="mt-1">
      <hr class="my-2">

      <slot name="filter" :data="filterData" />
    </b-collapse>

    <b-modal
      id="modalForm"
      v-if="!withoutFormData"
      :title="'Formulir ' + $route.name"
      header-class="bg-light text-primary py-1"
      no-close-on-backdrop
      :size="modalSize"
      hide-footer>

      <form @submit.prevent="onSubmit" class="d-block">
        <slot name="form" :data="formData" />
      </form>
    </b-modal>

    <b-modal
      id="modalUpload"
      :title="'Upload ' + $route.name"
      header-class="bg-light text-primary py-1"
      no-close-on-backdrop
      hide-footer>
      <form @submit.prevent="onUpload" class="d-block">
        <slot name="upload" :data="formUpload" />
      </form>
    </b-modal>

    <b-modal id="modalDetail" hide-footer hide-header>
      <div class="d-block text-center" v-if="selectedItem">
        <slot name="detail" :data="detailData" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    apiUrl: String,
    selectedItem: Object,
    search: String,
    formData: Object,
    detailData: Object,
    filterData: Object,
    formUpload: Object,
    withoutAdd: Boolean,
    withoutEdit: Boolean,
    withoutDelete: Boolean,
    withoutDetail: Boolean,
    modalSize: {
      default: 'md',
      type: String
    },
    buttonAppend: {
      default: false,
      type: Boolean
    },
    modeEditForm: false
  },

  mounted () {
    this.getUserAccess()

    this.searchInput = this.search

    // console.log(this.withoutAdd)
    // console.log(this.accessWithoutAdd)
  },

  data () {
    return {
      searchInput: '',
      lastInsertId: null,
      accessWithoutAdd: false,
      accessWithoutEdit: false,
      accessWithoutDelete: false,
      accessWithoutDetail: false
    }
  },

  computed: {
    withoutDetailData () {
      if (this.detailData) {
        return Object.keys(this.detailData).length === 0 && this.detailData.constructor === Object
      } else {
        return true
      }
    },
    withoutFormData () {
      if (this.formData) {
        return Object.keys(this.formData).length === 0 && this.formData.constructor === Object
      } else {
        return true
      }
    },
    isReadOnlyUser () {
      if (
        this.accessWithoutAdd === true &&
        this.accessWithoutEdit === true &&
        this.accessWithoutDelete === true &&
        this.accessWithoutDetail === true
      ) {
        return true
      } else {
        return false
      }

      // return this.$store.state.user.userData.userId === 94 ||
      //   this.$store.state.user.userData.userId === 96 ||
      //   this.$store.state.user.userData.userId === 97 ||
      //   this.$store.state.user.userData.userId === 99 ||
      //   this.$store.state.user.userData.userId === 98
    }
  },

  methods: {
    onRefresh () {
      this.$emit('update:search', '')
      this.$emit('refresh')
    },
    onSearch (value) {
      this.$emit('update:search', value)
    },

    getUserAccess () {
      const roles = this.$store.state.user.userData.roles

      console.log(this.$store.state.user.userData)

      for (let i = 0; i < roles.length; i++) {
        const roleMenus = roles[i].RoleMenus

        for (let j = 0; j < roleMenus.length; j++) {

          if (this.$route.fullPath === roleMenus[j].Menu.Url) {

            const roleMenu = roleMenus[j]

            // console.log(roleMenu)

            if (roleMenu.AccessCreate === 1) {
              this.accessWithoutAdd = false
            } else {
              this.accessWithoutAdd = true
            }

            if (roleMenu.AccessDelete === 1) {
              this.accessWithoutDelete = false
            } else {
              this.accessWithoutDelete = true
            }

            if (roleMenu.AccessDetail === 1) {
              this.accessWithoutDetail = false
            } else {
              this.accessWithoutDetail = true
            }

            if (roleMenu.AccessUpdate === 1) {
              this.accessWithoutEdit = false
            } else {
              this.accessWithoutEdit = true
            }
          }
        }
      }

      if (this.withoutAdd === true) {
        this.accessWithoutAdd = true
      }

      if (this.withoutEdit === true) {
        this.accessWithoutEdit = true
      }

      if (this.withoutDelete === true) {
        this.accessWithoutDelete = true
      }

      if (this.withoutDetail === true) {
        this.accessWithoutDetail = true
      }      
    },

    createNewItem () {
      if (this.withoutFormData) {
        return
      }
      
      // this.$emit('update:selectedItem', {})
      Object.assign(this.$parent.$data.scopedFormData, this.$parent.$options.data().scopedFormData)

      this.modeEditForm = false
      this.$emit('add')

      this.$bvModal.show('modalForm')
    },
    detailItem () {
      if (!this.detailData) {
        return
      }

      for (const key of Object.keys(this.detailData)) {
        this.detailData[key] = this.selectedItem[key]
      }
      
      this.$bvModal.show('modalDetail')
    },
    editRow () {
      if (this.withoutFormData) {
        return
      }

      this.modeEditForm = true
      this.$emit('edit')

      console.log(this.formData)

      for (const key of Object.keys(this.formData)) {
        if ((typeof this.selectedItem[key] === 'string') && this.selectedItem[key].includes('-') && Date.parse(this.selectedItem[key])) {
         this.formData[key] = new Date(this.selectedItem[key])
        } else 
        if (key === 'Password') {
          this.formData[key] = null
        // } else if (Array.isArray(this.selectedItem[key])) {
        //   this.formData[key] = this.selectedItem[key].map(item => item.ID)
        } else {
          this.formData[key] = this.selectedItem[key]
        }

      }

      this.$bvModal.show('modalForm')
    },
    deleteItem () {
      this.$root.$emit('bv::hide::popover')
      
      if (!this.selectedItem.ID || !this.apiUrl)
        return

      this.$axios.delete(`${this.apiUrl}/${this.selectedItem.ID}`).then(res => {
        this.$emit('refresh')

        this.$bvToast.toast('Data berhasil dihapus', {
          title: 'Terhapus!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      })
    },
    onSubmit () {
      let url = this.apiUrl

      if (this.modeEditForm) {
        url = `${this.apiUrl}/${this.formData.ID}`
      }

      for (const key of Object.keys(this.formData)) {
        if (typeof(this.formData[key]) === 'boolean') {
          this.formData[key] = (this.formData[key] ? 1 : 0 )
        } else if (this.formData[key] instanceof Date) {
          this.formData[key] = this.$helper.dateToYMD(this.formData[key])
        }
      }

      // validation for employee work leave
      if (url.startsWith('/employee-work-leave')) {
        // if (!this.formData.EmployeeID) {
        //   this.$bvToast.toast('Pegawai harus diisi', {
        //     title: 'Gagal!!',
        //     variant: 'danger',
        //     solid: true,
        //     toaster: 'b-toaster-bottom-right',
        //     appendToast: true
        //   })
          
        //   return
        // }

        if (!this.formData.EmployeeWorkLeaveTypeID) {
          this.$bvToast.toast('Alasan harus diisi', {
            title: 'Gagal!!',
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-right',
            appendToast: true
          })

          return
        }
      }

      this.$axios.post(url, this.formData).then(res => {
        this.$emit('refresh')
        this.$bvModal.hide('modalForm')

        this.lastInsertId = res.data.ID

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })

        if (this.formUpload) {
          this.$bvModal.show('modalUpload')
        }
      })
    },

    onUpload () {
      let formData = new FormData()

      for (const key of Object.keys(this.formUpload)) {
        if (!this.formUpload[key]) {
          this.$bvToast.toast('File belum dipilih', {
            title: 'Gagal!!',
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-right',
            appendToast: true
          })

          return
        }

        formData.append(key, this.formUpload[key])
      }

      const url = `/upload${this.apiUrl}/${this.lastInsertId}` 

      this.$axios.post(
        url,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(response => {
        this.$emit('refresh')
        this.$bvModal.hide('modalUpload')

        this.$bvToast.toast('Berhasil diunggah', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      })
    }
  }

}
</script>

<style scoped>
  button {
    margin-right: 0.3rem;
    font-size: 0.75rem;
    font-weight: bold;
  }
  span.text, span.icon {
    padding-top: 0.15rem !important;
    padding-bottom: 0.15rem !important;
  }
</style>